import { useQuery } from '@tanstack/react-query';
import { getConfigCounts, CountsResponse } from '../services/configs-api';

/**
 * TanStack Query hook for fetching per-type configuration counts.
 * Used by TypeFilterTabs badges.
 */
export function useConfigCounts() {
  return useQuery<CountsResponse>({
    queryKey: ['configs', 'counts'],
    queryFn: () => getConfigCounts(),
    staleTime: 30_000, // 30 seconds
  });
}
